export const crimeAgainstPersonCodes = [
  '09A',
  '09B',
  '09C',
  '100',
  '11A',
  '11B',
  '11C',
  '11D',
  '13A',
  '13B',
  '13C',
  '36A',
  '36B',
  '64A',
  '64B',
  // '90Z',
];

export const crimeAgainstSocietyCodes = [
  '35A',
  '35B',
  '370',
  '39A',
  '39B',
  '39C',
  '39D',
  '40A',
  '40B',
  '40C',
  '520',
  '720',
  '90B',
  '90C',
  '90D',
  '90E',
  '90F',
  '90G',
  '90H',
  '90J',
  // '90Z',
];

export const crimeAgainstPropertyCodes = [
  '200',
  '510',
  '220',
  '250',
  '290',
  '270',
  '210',
  '26A',
  '26B',
  '26C',
  '26D',
  '26E',
  '26F',
  '26G',
  '23A',
  '23B',
  '23C',
  '23D',
  '23E',
  '23F',
  '23G',
  '23H',
  '240',
  '120',
  '280',
  '90A',
  // '90Z',
];

export const kidnappingOffenses = ['100'];

export const drugNarcoticOffenses = ['35A', '35B'];

export const gamblingOffense = ['39B', '39C'];

export const motorVehicleTheftOffenseCode = '240';

export const MotorVehiclePropertyType = Object.freeze({
  AUTOMOBILE: '03', // 03 = Automobiles
  BUS: '05', // 05 = Buses
  OTHER_MOTOR_VEHICLE: '24', // 24 = Other Motor Vehicles
  RECREATIONAL_VEHICLE: '28', // 28 = Recreational Vehicles
  TRUCK: '37', // 37 = Trucks
});

// Includes both padded (03) and unpadded (3) formats to handle DB vs UI inconsistencies
export const motorVehicleTheftPropertyTypes = Object.freeze([
  ...new Set([
    ...Object.values(MotorVehiclePropertyType),
    ...Object.values(MotorVehiclePropertyType).map((v) => String(parseInt(v))),
  ]),
]);